// extracted by mini-css-extract-plugin
export default {"container":"CheckboxButton_container__KqKdK","wrapper":"CheckboxButton_wrapper__MH43h","titles":"CheckboxButton_titles__aHxTs","checked":"CheckboxButton_checked__lzSbI"};